<template>
  <div>
    <el-form :inline="true">
      <el-form-item prop="start_date">
        <el-date-picker
          style="width:200px"
          size="small"
          v-model="searchForm.start_date"
          type="date"
          placeholder="开始日期"
          value-format="yyyy-MM-dd"
          :clearable="false"
        ></el-date-picker>
        <span> -</span>
      </el-form-item>
      <el-form-item prop="end_date">
        <el-date-picker
          style="width:200px"
          size="small"
          v-model="searchForm.end_date"
          type="date"
          placeholder="结束日期"
          value-format="yyyy-MM-dd"
          :clearable="false"
        ></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-input placeholder="订单号" v-model="searchForm.buy_number" size="small" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-select
          placeholder="厂商名称"
          v-model="searchForm.supplier"
          size="small"
          clearable
          filterable
        >
          <el-option
            v-for="(item,index) in $store.state.supplierList"
            :key="index"
            :label="item"
            :value="item"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select
          placeholder="产品"
          v-model="searchForm.product_id"
          size="small"
          clearable
          filterable
        >
          <el-option
            v-for="item in productList"
            :key="item.id"
            :label="`${item.product_name}${item.product_size}(${item.customer_name})`"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select
          placeholder="材质"
          v-model="searchForm.material_name"
          size="small"
          clearable
          filterable
        >
          <el-option
            v-for="(item,index) in $store.state.materialNameList"
            :key="index"
            :label="item"
            :value="item"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select
          placeholder="规格"
          v-model="searchForm.material_size"
          size="small"
          clearable
          filterable
        >
          <el-option
            v-for="(item,index) in $store.state.materialSizeList"
            :key="index"
            :label="item"
            :value="item"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select v-model="searchForm.is_come" size="small" placeholder="到料情况" clearable>
          <el-option label="到料OK" value="1"></el-option>
          <el-option label="到料不足" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-search"
          @click="searchForm.page = 1;getList()"
        >搜索</el-button>
      </el-form-item>
      <el-form-item style="float:right">
        <el-button size="small" icon="el-icon-download"  @click="getExcelPath">另存为Excel</el-button>
      </el-form-item>
    </el-form>
    <el-table
      ref="buyOrderTable"
      :data="buyOrderTableList"
      highlight-current-row
      v-loading="tableLoading"
      @sort-change="sortChange"
      @row-click="row=>{$refs['buyOrderTable'].toggleRowExpansion(row)}"
      @expand-change="row=>{currentExpandID = row.id}"
    >
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-table :data="props.row.materialList" :border="true">
            <el-table-column label="序号" align="center">
              <template slot-scope="scope">
                <div>{{scope.$index+1}}</div>
              </template>
            </el-table-column>
            <el-table-column label="材质" prop="material_name" align="center"></el-table-column>
            <el-table-column label="规格" prop="material_size" align="center" width="200px">
              <template slot-scope="scope">
                <span v-for="(sizeNumber,idx) in scope.row.material_size.split('*')" :key="idx">
                  <span v-if="sizeNumber!==''">
                    <span
                      v-if="sizeNumber.indexOf('/')===-1"
                      style="display:inline-block"
                    >{{sizeNumber.replace('@','↧').replace('^','φ')}}</span>
                    <span style="display:inline-block" v-else>
                      <span
                        style="display:inline-block;text-align:right"
                      >{{sizeNumber.split(/[+|-]/)[0].replace('@','↧').replace('^','φ')}}</span>
                      <span style="position:relative;width:32px;display:inline-block">
                        <sup
                          style="position:absolute;left:0px;bottom:5px;width:40px;display:inline-block;line-height:10px;text-align:left"
                        >{{sizeNumber.match(/[+|-]/)[0]+sizeNumber.split(/[+|-]/)[1].split('/')[0]}}</sup>
                        <sub
                          style="position:absolute;left:2px;top:-5px;width:40px;display:inline-block;line-height:10px;text-align:left"
                        >{{sizeNumber.match(/\/(.)/)[1]+sizeNumber.split(/[+|-]/)[2]}}</sub>
                      </span>
                    </span>
                    <span v-if="idx+1 !== scope.row.material_size.split('*').length">*</span>
                  </span>
                </span>
              </template>
            </el-table-column>
            <el-table-column label="重量(kg)" prop="buy_count" align="center"></el-table-column>
            <el-table-column label="单价(元/kg)" prop="buy_price" align="center"></el-table-column>
            <el-table-column label="关联产品" align="center">
              <template slot-scope="scope">
                <div
                  v-if="scope.row.product_id"
                >{{`${scope.row.product_name} ${scope.row.product_size} (${scope.row.customer_name})`}}</div>
              </template>
            </el-table-column>
            <el-table-column label="产品交期" prop="deliver_date" align="center"></el-table-column>
            <el-table-column label="来料重量" prop="come_weight" align="center"></el-table-column>
            <el-table-column label="来料数量" prop="come_count" align="center"></el-table-column>
            <el-table-column label="来料日期" prop="come_date" align="center"></el-table-column>
            <el-table-column label="备注" prop="remark" align="center"></el-table-column>
            <el-table-column label="操作" align="center" width="100px" fixed="right">
              <template slot-scope="scope">
                <el-link type="primary" @click="showEdit(scope.row,props.row.supplier)">编辑</el-link>
                <el-divider direction="vertical"></el-divider>
                <el-link type="primary" @click="showCome(scope.row,props.row.supplier)">来料</el-link>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </el-table-column>
      <el-table-column prop="buy_number" label="订单号" align="center" sortable="custom"></el-table-column>
      <el-table-column prop="supplier" label="厂商名称" align="center"></el-table-column>
      <el-table-column prop="buy_date" label="采购日期" align="center" sortable="custom"></el-table-column>
      <el-table-column prop="create_time" label="创建时间" align="center" sortable="custom"></el-table-column>
      <el-table-column label="操作" align="center" fixed="right" width="100px">
        <template slot-scope="scope">
          <el-link type="primary" @click.stop="goPrint(scope.row)">打印</el-link>
          <el-divider direction="vertical"></el-divider>
          <el-popconfirm
            confirmButtonText="确认"
            cancelButtonText="取消"
            icon="el-icon-warning-outline"
            iconColor="red"
            title="确定删除吗？"
            @click.native="(e)=>{e.stopPropagation()}"
            @onConfirm="deleteBuyOrder(scope.row.id)"
          >
            <el-link slot="reference" type="primary">删除</el-link>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      style="margin-top:15px"
      :total="buyOrderTableTotal"
      :current-page.sync="searchForm.page"
      @current-change="(page)=>{this.searchForm.page = page;this.getList()}"
      @size-change="(size)=>{this.searchForm.pageSize = size;this.searchForm.page = 1;this.getList()}"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="10"
      layout="prev, pager, next, ->, total, sizes"
      align="center"
    ></el-pagination>
    <el-dialog title="编辑" :visible.sync="editDialogVisible" width="700px">
      <el-form ref="editForm" :model="editForm" label-width="280px" v-loading="editLoading">
        <el-form-item
          label="材料"
        >
          <el-select v-model="selectedMaterial" style="width:200px" size="small" @change="materialChange" filterable>
            <el-option v-for="item in materialList" :key="item.id" :value="item.id" :label="`${item.material_name} ${item.material_size}`"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="重量"
          prop="buy_count"
          :rules="{ pattern: /^\d*$/, message: '请输入数字', trigger: 'blur' }"
        >
          <el-input v-model="editForm.buy_count" style="width:200px" size="small"></el-input>
        </el-form-item>
        <el-form-item
          label="单价"
          prop="buy_price"
          :rules="{ pattern: /^[0-9]*(\.[0-9]{1,2})?$/, message: '请输入数字(最多两位小数)', trigger: 'blur' }"
        >
          <el-input v-model="editForm.buy_price" style="width:200px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="交付日期" prop="come_date">
          <el-date-picker
            size="small"
            v-model="editForm.deliver_date"
            type="date"
            placeholder="选择日期"
            style="width:200px"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="editForm.remark" style="width:200px" size="small"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="editDialogVisible=false">取消</el-button>
        <el-button size="small" type="primary" @click="updateBuyOrder">确认</el-button>
      </span>
    </el-dialog>
    <el-dialog title="来料" :visible.sync="comeDialogVisible" width="700px">
      <el-form ref="comeForm" :model="comeForm" label-width="280px">
        <el-form-item label="来料日期" prop="come_date">
          <el-date-picker
            size="small"
            v-model="comeForm.come_date"
            type="date"
            placeholder="选择日期"
            style="width:200px"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        </el-form-item>
        <el-form-item
          label="来料重量"
          prop="come_weight"
          :rules="{ pattern: /^\d*$/, message: '请输入数字', trigger: 'blur' }"
        >
          <el-input @input="getComeCount" v-model="comeForm.come_weight" style="width:200px" size="small"></el-input>&nbsp;kg
        </el-form-item>
        <el-form-item
          label="来料数量"
          prop="come_count"
          :rules="{ pattern: /^\d*$/, message: '请输入数字', trigger: 'blur' }"
        >
          <el-input v-model="comeForm.come_count" style="width:200px" size="small"></el-input>&nbsp;支
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="comeDialogVisible=false">取消</el-button>
        <el-button size="small" type="primary" @click="updateCome">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getBuyOrderList, deleteBuyOrder, updateCome, updateBuyOrder, addProduce, getSelectMaterial, createBuyOrderExcel, getProductSelectList } from '../api/index'
import { baseURL } from '../config/App'
export default {
  data () {
    return {
      tableLoading: false,
      editLoading: false,
      currentExpandID: '',
      searchForm: {
        start_date: new Date(new Date().getTime() - 518400000).format('yyyy-MM-dd'),
        end_date: new Date().format('yyyy-MM-dd'),
        buy_number: '',
        product_id: '',
        material_name: '',
        material_size: '',
        supplier: '',
        is_come: '',
        sortType: 'id',
        order: 'desc',
        page: 1,
        pageSize: 10
      },
      productList: [],
      editDialogVisible: false,
      editForm: {},
      comeDialogVisible: false,
      comeForm: {},
      buyOrderTableTotal: null,
      buyOrderTableList: [],
      materialList: [],
      selectedMaterial: '',
      autoCreateProduce: {
        productList: [
          {
            product_id: '',
            come_count: '',
            come_date: null,
            supplier: ''
          }
        ]
      }
    }
  },
  mounted () {
    this.getList()
    this.getProductSelectList()
  },
  methods: {
    getProductSelectList () {
      getProductSelectList().then(res => {
        if (res.data.status === 200) {
          this.productList = res.data.data
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    materialChange (id) {
      let selectedItem = this.materialList.find(item => item.id === id)
      this.editForm.material_name = selectedItem.material_name
      this.editForm.material_size = selectedItem.material_size
      this.editForm.product_id = selectedItem.product_id
    },
    sortChange (sortInfo) {
      this.searchForm.sortType = sortInfo.prop
      if (sortInfo.order === 'ascending') {
        this.searchForm.order = 'asc'
      } else if (sortInfo.order === 'descending') {
        this.searchForm.order = 'desc'
      } else {
        this.searchForm.sortType = 'id'
        this.searchForm.order = 'desc'
      }
      this.searchForm.page = 1
      this.getList()
    },
    updateBuyOrder () {
      this.$refs['editForm'].validate(valid => {
        if (valid) {
          updateBuyOrder(this.editForm).then(res => {
            if (res.data.status) {
              this.$message.success(res.data.msg)
              this.editDialogVisible = false
              this.getList()
            } else {
              this.$message.error(res.data.msg)
            }
          })
        }
      })
    },
    showEdit (row, supplier) {
      this.editForm = {
        id: row.id,
        material_name: row.material_name,
        material_size: row.material_size,
        product_id: row.product_id,
        buy_count: row.buy_count,
        buy_price: row.buy_price,
        deliver_date: row.deliver_date,
        remark: row.remark
      }
      this.editLoading = true
      getSelectMaterial().then(res => {
        if (res.data.status === 200) {
          this.materialList = res.data.data
          this.selectedMaterial = `${row.material_name} ${row.material_size}`
          this.editLoading = false
        } else {
          this.$message.error(res.data.msg)
        }
      })
      this.editDialogVisible = true
    },
    updateCome () {
      this.$refs['comeForm'].validate(valid => {
        if (valid) {
          updateCome(this.comeForm).then(res => {
            if (res.data.status) {
              this.comeDialogVisible = false
              if (this.comeForm.come_count > 0) {
                this.$confirm('操作成功，是否自动创建生产单?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'success'
                }).then(() => {
                  this.autoCreateProduce.productList[0].come_count = this.comeForm.come_count
                  this.autoCreateProduce.productList[0].come_date = this.comeForm.come_date
                  addProduce(this.autoCreateProduce).then(res => {
                    if (res.data.status === 200) {
                      this.$message.success(res.data.msg)
                    } else {
                      this.$message.error(res.data.msg)
                    }
                  })
                  this.getList()
                }).catch(() => {
                  this.getList()
                })
              }
            } else {
              this.$message.error(res.data.msg)
            }
          })
        }
      })
    },
    getComeCount (val) {
      if (this.comeForm.material_size.split('*').length === 2) {
        var regMatch = this.comeForm.material_size.match(/([\d|.]+).*\*([\d|.]+)/)
        var preKg = (regMatch[1] / 2) * (regMatch[1] / 2) * 3.14 * regMatch[2] * 0.00000785
      } else if (this.comeForm.material_size.split('*').length === 3) {
        regMatch = this.comeForm.material_size.match(/([\d|.]+).*\*([\d|.]+).*\*([\d|.]+)/)
        preKg = regMatch[1] * regMatch[2] * regMatch[3] * 0.00000785
      }
      this.comeForm.come_count = Math.round(val / preKg)
    },
    showCome (row, supplier) {
      this.autoCreateProduce.productList[0].supplier = supplier
      this.autoCreateProduce.productList[0].product_id = row.product_id
      this.comeForm = {
        id: row.id,
        material_size: row.material_size,
        come_date: row.come_date ? row.come_date : new Date().format('yyyy-MM-dd'),
        come_weight: row.come_weight,
        come_count: row.come_count
      }
      this.comeDialogVisible = true
    },
    deleteBuyOrder (id) {
      deleteBuyOrder({ id }).then(res => {
        if (res.data.status === 200) {
          this.$message.success(res.data.msg)
          this.getList()
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    goPrint (row) {
      let routeData = this.$router.resolve({
        path: '/buyOrderPrintPage',
        query: {
          info: JSON.stringify(row)
        }
      })
      window.open(routeData.href, '_blank')
    },
    getExcelPath () {
      this.$prompt('请输入文件名', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(({ value }) => {
        createBuyOrderExcel(this.searchForm).then(res => {
          console.log(res)
          if (res.data.status === 200) {
            value || (value = '未命名')
            window.location.href = baseURL + '/index/getExcel?path=' + res.data.data + '&filename=' + value
          } else {
            this.$message.error(res.data.msg)
          }
        })
      }).catch(() => {
        this.$message({
          type: 'error',
          message: '下载失败'
        })
      })
    },
    getList () {
      this.tableLoading = true
      getBuyOrderList(this.searchForm).then(res => {
        if (res.data.status === 200) {
          this.buyOrderTableList = res.data.data
          this.buyOrderTableTotal = res.data.total
          this.tableLoading = false
          this.$nextTick(() => {
            let row = res.data.data.find(item => item.id === this.currentExpandID)
            if (row !== undefined) {
              this.$refs['buyOrderTable'].toggleRowExpansion(row, true)
            }
          })
        } else {
          this.$message.error(res.data.msg)
        }
      })
    }
  }
}
</script>

<style>
</style>
